import React from 'react';
import { Button } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { FilterAltIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';

const FilterButton = ({ onClick, initInspectionFilterValues, inspectionsFilter }) => {
  return (
    <Button
      onClick={onClick}
      endIcon={<FilterAltIcon />}
      variant="outlined"
      color={
        JSON.stringify(initInspectionFilterValues) === JSON.stringify(inspectionsFilter)
          ? 'primary'
          : 'info'
      }
    >
      <ButtonSpan>
        <FormattedMessage id="button.filter" />
      </ButtonSpan>
    </Button>
  );
};

export default FilterButton;
